export const getIDfromPath = () => {
  const location = window.location;
  const paths = location.pathname.split("/");
  if (paths.length > 1) {
    return paths[2];
  }
  return null;
};
export const getSafeValue = (value) => {
  if (value) return value;
  //Return empty string if null
  return "";
};

export const isEmptyJsonObject = (obj) => {
  return obj == undefined || (obj && Object.keys(obj).length === 0 && obj.constructor === Object);
};

export const clone = (obj) => {
  if (obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  return obj;
};
export const nullToEmptyString = (o) => {
  return o ? o : "";
};